import moment from 'moment'

// Check-in date rules shared by every screen that can check in an allocation.

function checkoutHour() {
    let h = 12;
    try
    {
        let timesettingObj = JSON.parse(localStorage.getItem('timesetting'));
        let h1 = timesettingObj.data.end;
        if(h1 !== null && h1 !== undefined)
        {
            h = parseInt(h1.split(':')[0]);
        }
    }
    catch (err)
    {
    }
    return h;
}

// True when today is before the allocation's arrival date.
export function isBeforeArrival(start) {
    return moment().isBefore(moment(start).local().startOf('day'));
}

// Returns the reason check-in is not allowed for this allocation, or null when it is allowed.
export function checkinBlockReason(start, end) {
    if (isBeforeArrival(start))
    {
        return `Invalid: Check-In NOT ALLOWED before the arrival date (${moment(start).local().format('DD-MM-YYYY')}).`;
    }

    let due = moment(end).local().add(checkoutHour(), 'h').format('YYYY-MM-DD HH:mm:ss');
    let now = moment().format('YYYY-MM-DD HH:mm:ss');
    if (due <= now)
    {
        return `Invalid: Check-In NOT ALLOWED. This allocation is already due Check Out.`;
    }

    return null;
}
